import api from "../api/api";

export const ShopPageBannerServices = {
  getRandom: async () => {
    const res = await api.get("/shop-page-banners/random");
    return res?.data?.data || null; // single banner object
  },
};
